/* ─── Root ─── */

.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.root[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

/* ─── Label ─── */

.label {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  font-family: var(--font-sans);
  font-weight: 600;
  color: var(--md-on-surface-variant);
}

.root[data-invalid] .label {
  color: var(--md-error);
}

/* ─── Trigger ─── */

.trigger {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  height: 3rem;
  padding-inline: var(--space-4);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
  background: var(--md-surface-container-highest);
  border: none;
  border-radius: var(--shape-sm);
  cursor: pointer;
  outline: 2px solid transparent;
  transition: outline-color var(--motion-duration-short3)
      var(--motion-easing-standard),
    background var(--motion-duration-short3) var(--motion-easing-standard);
}

.trigger:focus-visible {
  outline-color: var(--md-primary);
  background: var(--md-surface-container);
}

.root[data-invalid] .trigger {
  outline-color: var(--md-error);
}

.root[data-invalid] .trigger:focus-visible {
  outline-color: var(--md-error);
  background: var(--md-surface-container);
}

.trigger:disabled {
  cursor: not-allowed;
}

/* ─── Chevron ─── */

.chevron {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  color: var(--md-on-surface-variant);
  transition: transform var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.trigger[data-popup-open] .chevron {
  transform: rotate(180deg);
}

/* ─── Positioner ─── */

.positioner {
  z-index: var(--z-popover);
}

/* ─── Popup ─── */

.popup {
  background: var(--md-surface-container);
  border-radius: var(--shape-sm);
  box-shadow: var(--elevation-2);
  min-width: var(--anchor-width);
  max-height: 20rem;
  overflow: auto;
  outline: none;
  padding: var(--space-1);
}

.popup[data-starting-style],
.popup[data-ending-style] {
  opacity: 0;
  transform: scale(0.95);
}

.popup {
  transition: opacity var(--motion-duration-short3)
      var(--motion-easing-standard),
    transform var(--motion-duration-short3) var(--motion-easing-standard);
}

/* ─── List ─── */

.list {
  outline: none;
}

/* ─── Scroll arrows ─── */

.scrollArrow {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  color: var(--md-on-surface-variant);
}

.scrollArrow svg {
  width: 0.875rem;
  height: 0.875rem;
}

/* ─── Item ─── */

.item {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-height: 3rem;
  padding-block: var(--space-2);
  padding-inline: var(--space-3);
  font-family: var(--font-sans);
  color: var(--md-on-surface);
  cursor: pointer;
  outline: none;
  user-select: none;
  transition: background var(--motion-duration-short3)
    var(--motion-easing-standard);
}

.item[data-highlighted] {
  background: var(--md-surface-container-highest);
}

.item[data-disabled] {
  opacity: 0.38;
  cursor: not-allowed;
}

/* ─── Item indicator (checkmark) ─── */

.itemIndicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  color: var(--md-primary);
}

.itemIndicator svg {
  width: 0.75rem;
  height: 0.75rem;
}

/* ─── Group ─── */

.group {
  padding-block: var(--space-1);
}

.group + .group {
  border-block-start: 1px solid var(--md-outline-variant);
}

/* ─── Group label ─── */

.groupLabel {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
  padding-inline: var(--space-3);
  padding-block: var(--space-2);
  font-family: var(--font-sans);
  font-weight: 600;
  color: var(--md-on-surface-variant);
}

/* ─── Description ─── */

.description {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-on-surface-variant);
  margin: 0;
}

/* ─── Error ─── */

.error {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
  font-family: var(--font-sans);
  color: var(--md-error);
  margin: 0;
}
